import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Card, Toolbar } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import FavouriteList from './FavouriteList.jsx';
import HOCSectionLoader from '../HOC/HOCSectionLoader.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';

const styles = theme => ({
    root: {
        width: '100%'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary
    }
});

class FavouriteExpansion extends React.Component {
    state = {
        expanded: null,
        data: this.props.favouriteData,
        loader: true
    };
    componentDidMount() {
        this.getData();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.favouriteData !== this.props.favouriteData) {
            this.setState({ data: this.props.favouriteData });
        }
    }
    getData = async () => {
        this.props.favouriteListAction();
    };

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false
        });
    };

    render() {
        const { classes } = this.props;
        const { expanded, data } = this.state;

        return (
            <HOCSectionLoader loading={this.props.favouriteLoader}>
                <h4>
                    {' '}
                    <FormattedMessage
                        id="myFavouriteList"
                        defaultMessage="My Favourite List"
                    />
                </h4>

                <div className="db-list-com">
                    {data.map(n => {
                        return (
                            <ExpansionPanel
                                className="dashboard-tabs"
                                key={n.key}
                                expanded={expanded === n.key}
                                onChange={this.handleChange(n.key)}
                            >
                                <ExpansionPanelSummary
                                    className="tabs-title"
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography className={classes.heading}>
                                        <b>{n.name}</b>
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails className="dashboard-tabs-expan">
                                    <div className="col-md-12 favorite-table">
                                        <FavouriteList data={n.providers} />
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        );
                    })}
                </div>
            </HOCSectionLoader>
        );
    }
}

FavouriteExpansion.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = ({ providers }) => {
    return {
        favouriteData: providers.favProviderList,
        favouriteLoader: providers.favProviderLoader
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);

export default composedComponent(FavouriteExpansion);



// WEBPACK FOOTER //
// ./src/components/Customer/FavouriteExpansion.jsx